import { FolkSandWebGPU } from '../folk-sand-webgpu';
FolkSandWebGPU.define();
export { FolkSandWebGPU };
//# sourceMappingURL=folk-sand-webgpu.js.map